module.exports = __webpack_public_path__ + "static/media/print-black.bbc7ee86.svg";